import { Component, OnInit } from '@angular/core';
import { ValidatorService } from 'src/app/services/validator.service';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';
import { MatDialog } from '@angular/material/dialog';
import { UsuarioLoginModal } from '../usuario-login-modal/usuario-login-modal.component';

@Component({
  selector: 'usuario-email-cadastro',
  templateUrl: './usuario-email-cadastro.component.html',
  styleUrls: ['./usuario-email-cadastro.component.scss']
})
export class UsuarioEmailCadastroComponent implements OnInit {

  public dataItem:any = {
    email: ""
  }; 
  public valid = null; 
  public loader = false;
  public subscribeMessage = null;
  public hasCadastro = false;

  constructor(
    private validator: ValidatorService,
    private api: ApiService,
    private app: AppService,
    public dialog: MatDialog
  ){ }

  /**
   * 
   * Check
   * 
   */
  _check(){

    this.validator.clear();

    this.validator.isEmail(this.dataItem.email,"email","- E-mail inválido.");

    if(this.validator.passes()){
      this.valid = true;
      this.verificarEmail();
    }else{
      this.valid = false; 
      this.hasCadastro  = false;
    }

  }
  /**
   * 
   * Verifica email
   * 
   */
  verificarEmail(){

    try{

      this.loader = true;

      this.api.loja().usuario().verificarEmail(this.dataItem.email).subscribe(response => {

        this.loader = false;

        if(response.status == 1){
          if(response.data == true){
            this.valid            = false;
            this.hasCadastro  = false;
            this.subscribeMessage = "Esse e-mail já está cadastrado.";
          }else{
            this.subscribeMessage = null;
            this.hasCadastro  = true;
            this._open();
          }
        }

      },(response) => {

        this.loader = false;

      });

    }catch(e){

      this.loader = true;

    }


  }
  /**
   * 
   * Open
   * 
   */
  _open(){

    this.dialog.open(UsuarioLoginModal,{
      width: "400px",
      height: "auto",
      disableClose: true,
      data: {  
        content: 4,
        email: this.dataItem.email
      }
    });

  }
  /***
   * 
   * Incializa as Funções
   * 
   */
  ngOnInit():void{}

}
